import React, { Fragment } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import handleRenderOption from "./handleRenderOption";
import useCatalogo from "./../../../hooks/useCatalogos";

const InitailValuesPais = {
  IdPais: 0,
  Nombre: "",
  Codigo: "0",
}

const AutoInputPaises = (props) => {
  const catalogoPaises = useCatalogo("Pais");
  const {
    name = "",
    label = "",
    target = InitailValuesPais,
    setTarget = () => {},
    error = false,
    helperText = "",
  } = props;

  const getOptionHangle = (event, valor) => {
    if (valor) {
      setTarget(valor);
    } else {
      setTarget(InitailValuesPais);
    }
  };

  return (
    <Fragment>
      <Autocomplete
        id={`id-auto-${name}`}
        value={target}
        options={catalogoPaises.sort((a, b) => a.Codigo > b.Codigo)}
        getOptionLabel={(option) => `${option.Nombre.trim()}`}
        style={{
          width: "97%",
          margin: "5px",
          paddingBottom: "0",
          fontWeight: "500",
        }}
        onChange={getOptionHangle}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            style={{ width: "100%" }}
            name={name}
            error={error}
            helperText={helperText}
          />
        )}
        renderOption={handleRenderOption}
      />
    </Fragment>
  );
};
export default AutoInputPaises;
